import Home from './home'
import CollectionRecord from './collectionRecord'
import ExchangePage from './exchangepage'
import ExchangeRecord from './exchangeRecord'
export default {
  Home,
  CollectionRecord,
  ExchangePage,
  ExchangeRecord
}
